import * as type from '../types/authTypes'

const initialState = {
    is_logged_in : false,
    login_error : false,
    user_data : null,
    is_loading : true
}
const counterReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.LOGIN_SUCCESS:
            return {
                ...state,
                is_logged_in: true,
                user_data : action.payload,
                is_loading : false
            };
        case type.LOGIN_ERROR:
            return {
                ...state,
                login_error : true,
                user_data : null,
                is_logged_in : false,
                is_loading : false
            };
        case type.LOGOUT_USER : 
            return {
                ...state,
                login_error : false,
                user_data : null,
                is_logged_in : false,
                is_loading : false
            };
        case type.SET_USER_DATA:
            return {
                ...state,
                user_data : action.payload
            }
        default:
            return {...state};
    }
};

export default counterReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/authReducer.js